import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';

const env = process.env.REACT_APP_ENV;

/**
 * 
 * @param {object} props - expects props.menu nestedMenuStructure object. See example at top of this file.
 *                                 routeAuth function. Can pass routeKey and receive route object if authorised, null if not.
 * @returns list of menu buttons capable of popping up a menu.
 * E.g. <Menu />
 *      <Button />
 *      <Button />
 *      ...
 *      <Button />
 * 
 * When each button is clicked <Menu> is anchored to the button and the correct <MenuItem> contents render as the contents.
 */
export default function PopUpMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuList, setMenuList] = useState([]);

  const topMenuItemColor = () => { // theme is passed as parameter
    return (env === 'production') ? 'primary.main' : 'nonprod.main'; // could get these as e.g. theme.palette.primary.main
  };

  const handleClick = (event, menuItemList) => {
      setAnchorEl(event.currentTarget);
      setMenuList(menuItemList);
  };

  const handleClose = () => {
      setAnchorEl(null);
  };

  const menuButtonList = [];

  props.menu.forEach(menu => {
      const menuItemList = [];
      menu.items.forEach((menuItem) => {
          const routeItem = props.routeAuth(menuItem.routeKey);

          if (routeItem) { // User is authorised for this route - show it
              const thisMenuItem = (
                  <MenuItem component={Link} to={routeItem.href} onClick={handleClose} sx={{'&:hover': { color: topMenuItemColor}}}  key={menuItem.itemLabel}>
                      {menuItem.itemLabel}
                  </MenuItem>
              );
              menuItemList.push(thisMenuItem);
          }
      });

      if (menuItemList.length > 0) {
        //
        // This user is allowed access to at least one item on this sub-menu. So show the sub-menu.
        //
        const theMenuButton =
          <Button size="large" onClick={(e) => { handleClick(e, menuItemList) }} sx={{color: 'white'}} key={menu.menuLabel}>
              {menu.menuLabel}
          </Button>;
        menuButtonList.push(theMenuButton);
      }
  });

  //
  // menuButtonList is now a list of buttons representing the sub-menus for which this user can access
  // at least one item.
  // Each button in menuButtonList has a onClick even that sets two pieces of state:
  // First the menu list is set to the menu items available on this sub-menu.
  // Second the anchor element for the Menu is set to the selected button ensuring the menu pops up in that location.
  //
  return (
    <>
      { menuButtonList }
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>{menuList}</Menu>
    </>
  );
}